'use strict';

var ngModule = angular.module('breakmarkApp');

ngModule.directive('storeProductsTable', function ($rootScope, ModalService, $Products, $q, Upload, $timeout, $uibModal) {



    // Generate unique IDs for use as pseudo-private/protected names.
    // Similar in concept to
    // <http://wiki.ecmascript.org/doku.php?id=strawman:names>.
    //
    // The goals of this function are twofold:
    //
    // * Provide a way to generate a string guaranteed to be unique when compared
    //   to other strings generated by this function.
    // * Make the string complex enough that it is highly unlikely to be
    //   accidentally duplicated by hand (this is key if you're using `ID`
    //   as a private/protected name on an object).
    //
    // Use:
    //
    //     var privateName = makeId();
    //     var o = { 'public': 'foo' };
    //     o[privateName] = 'bar';
    function makeId() {
      // Math.random should be unique because of its seeding algorithm.
      // Convert it to base 36 (numbers + letters), and grab the first 12 characters
      // after the decimal.
      return '_' + Math.random().toString(36).substr(2, 19);

    };


	return {
		scope: {
			store: '='
		},
		templateUrl: 'directives/storeProductsTable/table.html',
		controller: function($scope) {

            // const storage = firebase.storage();
            // const storageRef = firebase.storage().ref();

			if (!$scope.store.products) $scope.store.products = [];

			$scope.delete = function(product) {

                let scope = $scope; // need this inside the controller for the modal

                let modalInstance = $uibModal.open({
                    animation: true,
                    template: `
                        <div class="modal-header">
                            <h3 class="modal-title">Delete "${product.name}"?</h3>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                            <button class="btn btn-danger" type="button" ng-click="delete()">Delete</button>
                        </div>`,
                    controller: function($scope, $uibModalInstance, product) {

                        $scope.delete = function () {

                            let index = scope.store.products.indexOf(product);

        					if (index > -1) scope.store.products.splice(index, 1);

                            scope.store.$save();

                            $uibModalInstance.close(product);
                        };

                        $scope.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                        };

                    },
                    resolve: {
                        product: function() {
                            return product;
                        }
                    },
                    size: 'sm'
                });

			};

			$scope.edit = function(product) {
	            // var scope = $rootScope.$new();
	            // scope.title = 'Edit a Product';
	            // scope.product = product;

                let modal = $uibModal.open({
                    size: 'lg',
                    scope: $scope,
                    animation: true,
                    templateUrl: 'directives/storeProductsTable/editModal.html',
                    controller: 'storeProductsTableEditProductModal',
                    resolve: {
                        product: function() {
                            return product;
                        },
                        store: function() {
                            return $scope.store;
                        }
                    }
                });

                modal.result.then(function (returnedStore) {
                    console.log('returnedStore', returnedStore);

                    $scope.store = returnedStore;

                    // $scope.store.$save().then( () => {
                    //     alert('saving store . . .');
                    // });

                }, function () {
                    console.info('modal-component dismissed at: ' + new Date());
                });
			};

			/* Provides the ability to copy an existing product into another. */
			$scope.copy = function(product) {

                let scope = $scope; // need this inside the controller for the modal

                let modalInstance = $uibModal.open({
                    animation: true,
                    template: `
                        <div class="modal-header">
                            <h3 class="modal-title">Copy "${product.name}"?</h3>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                            <button class="btn btn-success" type="button" ng-click="copy()">Copy</button>
                        </div>`,
                    controller: function($scope, $uibModalInstance, product) {

                        $scope.copy = function () {

                            let copy = angular.copy(product);

                            copy.name = 'Copy of ' + copy.name;

                            copy.id = makeId();

                            scope.store.products.push(copy);

                            scope.store.$save();

                            $uibModalInstance.close(copy);
                        };

                        $scope.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                        };

                    },
                    resolve: {
                        product: function() {
                            return product;
                        }
                    }
                });
			};

			/* Helper function that determines is a given icon should show in the table. */
			$scope.hasProperty = function(item, key) {
				return  _.chain(item.properties || []).pluck('type').contains(key).value();
			};

			/* This function provides the option to find and attach a base product to the store. */
			$scope.add = function() {
				var scope = $rootScope.$new();

	            var modal = ModalService.showModal({
	                templateUrl: 'directives/storeProductsTable/modal.html',
	                scope: scope,
	                controller: function($element, close) {
						scope.search = {};
						scope.products = $Products.all();

                        if(!$scope.store.products){
                            $scope.store.products = [];
                        }

						/* This function is used to take a base product and
						   attach it to the store in the products key. */

	                    scope.attachProduct = function(item) {

                            // Important!!!
                            // The $id that's included in the product relates back to the cloned categlog product
                            // .id is our own custom made ID that is long enough as to never conflict
                            // this is used to save images/files and perhaps other things in the future

                            item.id = makeId();

							/* Copy and attach to the store properties. */
							$scope.store.products.push(angular.copy(item));

							/* close this modal */
	                        $element.modal('hide');
	                        close(null, 1000);
	                    };
	                }
	            }).then(function(modal) {
	                modal.element.modal();
	                modal.close.then(function(result) {});
	            });
			};
		}
	};
});
